import { render, staticRenderFns } from "./ZxFawuZhixingjinduTable.vue?vue&type=template&id=224983a2&"
import script from "./ZxFawuZhixingjinduTable.vue?vue&type=script&lang=js&"
export * from "./ZxFawuZhixingjinduTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports